"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _LoginInformation = _interopRequireDefault(require("../components/LoginInformation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Profile extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      authFailure: false
    };
  }
  render() {
    const {
      profileInformation
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
      className: "title is-1"
    }, "Profile"), profileInformation, /*#__PURE__*/_react.default.createElement(_LoginInformation.default, null));
  }
}
Profile.propTypes = {
  profileInformation: _propTypes.default.any
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Profile);
//# sourceMappingURL=Profile.js.map